export class CasinoApiError extends Error {
  constructor(message, { status = 0, code = "CASINO_API_ERROR", body = null } = {}) {
    super(message);
    this.name = "CasinoApiError";
    this.status = status;
    this.code = code;
    this.body = body;
  }
}

async function requestJson(url, options = {}) {
  const response = await fetch(url, {
    credentials: "include",
    ...options,
    headers: {
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...(options.headers || {}),
    },
  });

  const text = await response.text();
  let body = null;

  if (text) {
    try {
      body = JSON.parse(text);
    } catch {
      body = { error: text };
    }
  }

  if (!response.ok) {
    throw new CasinoApiError(
      body?.error || `Casino request failed with HTTP ${response.status}`,
      {
        status: response.status,
        code: body?.code || "CASINO_API_ERROR",
        body,
      }
    );
  }

  return body;
}

export function getCasinoProfile() {
  return requestJson("/api/user/profile");
}

export function getActiveRouletteSpin() {
  return requestJson("/api/gamble/roulette/active");
}

export function getRouletteLatest() {
  return requestJson("/api/gamble/roulette/latest");
}

export function lockRouletteBets(bets) {
  return requestJson("/api/gamble/roulette/lock", {
    method: "POST",
    body: JSON.stringify({ bets }),
  });
}

export function startRouletteSpin() {
  return requestJson("/api/gamble/roulette/spin", {
    method: "POST",
  });
}

export function settleRouletteSpin(spinId) {
  return requestJson("/api/gamble/roulette/settle", {
    method: "POST",
    body: JSON.stringify({ spinId }),
  });
}
